import { gql } from '@apollo/client'

export const GET_ZONE = gql`
  query GetZone($zoneId: ID) {
    zone(zoneId: $zoneId) {
      id
      name
      zonePath
      tier
      manager {
        fullName
        id
      }
      assignedUsers {
        id
        email
        name
        mainRole
        dateRemoved
      }
      parentId
      stores {
        id
        name
        internalStoreId
        image {
          id
          url
        }
        category
        address {
          address1
          address2
          city
          state
          postalCode
        }
      }
      subZones {
        id
        name
        numStores
        manager {
          fullName
        }
      }
    }
  }
`
